import styled from 'styled-components'
import { Text } from '@machobear/design-system'
import { vars } from '@machobear/design-system/css'

import { breakpoints } from '@/styles'

export const MultiOptionList = styled.div<{ disabled?: boolean }>`
  display: flex;
  border-radius: 4px;
  width: 100%;

  > :not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  > :not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-right: none;
  }

  ${props =>
    props.disabled &&
    `
    cursor: default;
    opacity: 0.5;
    pointer-events: none;
  `};
`

const ItemWrapper = styled.button<{ isSelected: boolean }>`
  border-radius: 4px;
  flex: 1;
  color: ${props =>
    props.isSelected
      ? vars.foregroundColor.white
      : vars.foregroundColor.neutral};
  background: ${props =>
    props.isSelected
      ? vars.backgroundColor.formAccent
      : vars.backgroundColor.white};
  height: 60px;
  cursor: pointer;
  padding: 16px 12px;
  border: 1px solid ${vars.borderColor.field};

  :hover {
    background: ${props =>
      props.isSelected
        ? vars.backgroundColor.formAccent
        : vars.backgroundColor.formAccentSoftHover};
  }

  svg {
    height: 16px;
    width: 16px;
    flex-shrink: 0;
    color: ${props =>
      props.isSelected
        ? vars.foregroundColor.white
        : vars.foregroundColor.neutral};
  }
`

const ClickWrapper = styled.div`
  pointer-events: none;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  @media (max-width: ${breakpoints.phoneMax}) {
    flex-direction: column;
    gap: 8px;
  }
`

interface MultiOptionItemProps {
  id: string | number
  clickId?: string
  label: string
  icon?: React.ElementType
  onClick: (id: string | number) => void
  selected: boolean
}

export const MultiOptionItem = ({
  id,
  clickId,
  label,
  icon: Icon,
  onClick,
  selected
}: MultiOptionItemProps) => {
  return (
    <ItemWrapper
      type="button"
      onClick={() => onClick(id)}
      isSelected={selected}
      id={clickId}
    >
      <ClickWrapper>
        {Icon && <Icon />}
        <Text
          size="small"
          weight="regular"
          tone={selected ? 'neutralInverted' : 'neutral'}
        >
          {label}
        </Text>
      </ClickWrapper>
    </ItemWrapper>
  )
}
